import React from 'react';

import { Box, Typography } from '@mui/material';

import PercentMeter from '../../../components/PercentMeter';
import { formatMoney } from '../../../Construction.utils';
import { DRAW_LINE_ITEM_COLUMN_KEY } from '../../DrawReviewDrawer.constants';

import { categoryCellStyles, requestedOverStyles } from './DrawLineItemsSection.styles';

const KEY = DRAW_LINE_ITEM_COLUMN_KEY;

export const getLineItemsConfig = () => ({
  [KEY.CATEGORY]: {
    label: 'Category',
    align: 'left',
    content: row => (
      <Box sx={categoryCellStyles}>
        <Typography variant="medium14">{row.category}</Typography>
        <Typography color="text.secondary" variant="regular12">
          {`Cost code ${row.costCode}`}
        </Typography>
      </Box>
    ),
  },
  [KEY.REQUESTED]: {
    label: 'Requested',
    align: 'right',
    content: row => (
      <Typography sx={row.isOverRemaining ? requestedOverStyles : undefined} variant="medium14">
        {formatMoney(row.requested)}
      </Typography>
    ),
  },
  [KEY.BUDGET_REMAINING]: {
    label: 'Budget Rem.',
    align: 'right',
    content: row => <Typography variant="regular14">{formatMoney(row.budgetRemaining)}</Typography>,
  },
  [KEY.PERCENT_COMPLETE]: {
    label: '% Complete',
    align: 'left',
    content: row => (
      <PercentMeter isOverBudget={row.isOverRemaining} percent={row.percentComplete} />
    ),
  },
});
